import { useNavigate } from "react-router";
import { MAP_NAV_ROOT_EMPTY, TMapNavRoot, useVVStore } from "./store";


export function useVVNav() {

    const mapNavRoot = useVVStore(state => state.mapNavRoot);
    const setMapNavRoot = useVVStore(state => state.setMapNavRoot);
    const nav = useNavigate();

    const setRoot = (r: string | TMapNavRoot | undefined) => {
        if (!r)
            setMapNavRoot(MAP_NAV_ROOT_EMPTY);
        else if (typeof r === 'string')
            setMapNavRoot((path: string) => r + path);
        else
            setMapNavRoot(r);
    }

    const buildRoot = (rootPath: string, query?: Record<string, string | number | boolean | undefined | null>) => {
        const params = new URLSearchParams();
        if (query) {
            for (const [key, value] of Object.entries(query)) {
                if (value !== undefined && value !== null && value) {
                    params.append(key, String(value));
                }
            }
        }
        //const queryString = Object.entries(params).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&');
        const queryString = params.toString();
        //console.log('queryString', queryString);
        return (path:string) => rootPath+path+ (queryString ? '?'+queryString:'');
    }

    const clearRoot = () => {
        setMapNavRoot(MAP_NAV_ROOT_EMPTY);
    }

    const toRoot = () => {
        const location = mapNavRoot('');
        nav(location || '/map');
    }

    const toDetail = (path: string) => {
        nav(mapNavRoot(path));
    }

    const detailPath = (path: string) => {
        return mapNavRoot(path);
    }

    const detailPathName = (path: string) => {
        const url = mapNavRoot(path);
        return url.split('?').shift();
    }

    const isRoot = () => {
        return window.location.pathname === detailPathName('');
    }

    const startsWith = (path: string) => {
        const location = mapNavRoot('');
        return location.startsWith(path);
    }

    const shareUrl = () => {
        const host = process.env.REACT_APP_API_BASE_URL?.indexOf('dev.') !== -1 ? 'https://dev.vizvedok.hu' : 'https://vizvedok.hu';
        let shareUrl = window.location.href.replace('http://localhost:3000', host);
        let check = mapNavRoot('XXXXX');
        check.split('XXXXX').forEach(part => {
            shareUrl = shareUrl.replace(part, '');
        })
        return shareUrl;
    }

    return {
        setRoot,
        buildRoot,
        clearRoot,

        toRoot,
        toDetail,
        to: nav,
        startsWith,
        get shareUrl() { return shareUrl() },
        detailPath,
        detailPathName,
        isRoot,
    }

}